module.exports = __webpack_public_path__ + "static/media/icon-cancel.9d5a22fa.svg";